import { Grid } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const RootContainer = styled(Grid)({
  width: "100%",
  minHeight: 100,
  minWidth: 400,
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  cursor: "default",
  borderTop: "1px solid black",
  marginTop: 10,
  padding: "10px 0",
});

export const Item = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "selected" && prop !== "useBold",
})<{ selected?: boolean; useBold?: boolean }>(
  {
    width: "100%",
    display: "flex",
    borderBottom: "1px solid #d3d3d352",
    marginBottom: "5px",
    padding: "5px 10px",
    justifyContent: "space-between",
    cursor: "pointer",

    "& div": {
      display: "flex",
    },
    "& span:nth-of-type(1)": {
      width: "10%",
    },
    "& span:nth-of-type(2)": {
      width: "25%",
    },
    "& span:nth-of-type(3)": {
      width: "30%",
    },
    "& span:nth-of-type(4)": {
      width: "15%",
    },
    "& span:nth-of-type(5)": {
      width: "20%",
    },
  },
  ({ selected, theme }) => ({
    ...(selected && { backgroundColor: alpha(theme.palette.primary.light, 0.2) }),
  }),
  ({ useBold }) => ({
    ...(useBold && { fontWeight: `bold` }),
  })
);
